import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { endpoints } from '../../api/endpoints';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { Box, Button, Modal, Paper, Stack, Switch, Typography } from '@mui/material';
import { TablePagination } from '../../components/pagination/Pagination';
import { useContext, useEffect, useState } from 'react';
import { useCrudForm } from '../../api/useCrudForm';
import { AppContext } from '../../contexts/AppContext';
import { toast } from 'react-toastify';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import moment from 'moment';
import { CustomAlertModal } from '../../components/modal/customAlertModal';

export default function PenaltyRateTable({ refetchData, loading, count, setSkip, setTake, take, skip, rows, showApproved }: any) {

    const [openApproveModal, setOpenApproveModal] = useState(false);
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [selectedData, setSelectedData] = useState<any>();

    const onSuccess = () => {
        setOpenApproveModal(false)
        setOpenVerifyModal(false)
        setSelectedData(null)
        refetchData({ isMainTable: showApproved })
    }

    const onError = () => {
        setOpenApproveModal(false)
        setOpenVerifyModal(false)
        setSelectedData(null)
    }

    const { user } = useContext(AppContext)

    useEffect(() => {
        refetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skip, take])

    return (<>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 460 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableHeadCell>S.N</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Penalty Rate</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Created By</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Created Date</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Verified By</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Verified Date</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Is Active</TableHeadCell>
                            <TableHeadCell align="left" minwidth={"120px"}>Is Verified</TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!rows || loading ? <TableRowsLoader rowsNum={5} colNum={8} />
                            : rows?.length <= 0 ? <TableRow>
                                <TableCell colSpan={8} align='center'>No Data Found</TableCell>
                            </TableRow>
                                : rows.map((row: any, index: number) => {
                                    return (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={row.id}>
                                            <TableCell style={{ padding: '4px 18px', fontSize: "12px" }}>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                                            <TableCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }}>{row.rate}</TableCell>
                                            <TableCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }}>{row?.createdUsername}</TableCell>
                                            <TableCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }}>{row.createdDate ? moment(row.createdDate).format('YYYY-MM-DD') : null}</TableCell>
                                            <TableCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }}>{row?.approvedUserName}</TableCell>
                                            <TableCell align="left" style={{ padding: '4px 8px', fontSize: "12px" }}>{row.approvedDate ? moment(row.approvedDate).format('YYYY-MM-DD') : null}</TableCell>
                                            <TableCell align="left" style={{ padding: '4px 8px' }}>
                                                <Switch
                                                    checked={row.isActive}
                                                    disabled={user?.role?.toLowerCase() === 'maker'}
                                                    onChange={() => {
                                                        if (row.isActive !== true) {
                                                            setSelectedData(row)
                                                            setOpenApproveModal(true)
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell align="left" style={{ padding: '4px 8px' }}>
                                                <Switch
                                                    checked={row.status}
                                                    disabled={!(user?.role?.toLowerCase() === 'checker')}
                                                    onChange={() => {
                                                        if (row.status !== 1) {
                                                            setSelectedData(row)
                                                            setOpenVerifyModal(true)
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                    </TableBody>
                </Table>
            </TableContainer>
            {rows && (rows?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper>

        <AlertModal
            customEndpoint={true}
            onSuccess={onSuccess}
            onError={onError}
            endpoint={`${endpoints.penaltyRate.active}?id=${selectedData?.id ?? ''}`}
            selectedData={selectedData}
            openAlertModal={openApproveModal}
            setOpenAlertModal={setOpenApproveModal}
            message={'Are you sure want to active base rate ?'}
        />

        <CustomAlertModal
            customEndpoint={true}
            onSuccess={onSuccess}
            onError={onError}
            endpoint={`${endpoints.penaltyRate.approve}?id=${selectedData?.id ?? ''}`}
            selectedId={selectedData?.id}
            openAlertModal={openVerifyModal}
            setOpenAlertModal={setOpenVerifyModal}
            message={'Are you sure want to verify this base rate ?'}
        />

    </>
    );
}

const AlertModal = ({ message, customEndpoint, endpoint, selectedData, openAlertModal, setOpenAlertModal, onSuccess, onError }: { message?: any, customEndpoint?: boolean, selectedData?: any, onSuccess: () => void, onError: () => void, endpoint: string, setOpenAlertModal: React.Dispatch<React.SetStateAction<boolean>>, openAlertModal: boolean }) => {

    const { get } = useCrudForm()

    const onSubmit = (values: any) => {

        get({
            endpoints: endpoint,
            onSuccess: (data: any) => {
                onSuccess()
                toast.success(data.message, { style: { background: '#3150A1' } })
            },
            onError: (error: any) => {
                toast.error(error?.message ?? error)
                onError()
            },
        })
    }

    return <Modal
        open={openAlertModal}
        onClose={onError}
    >
        <Box sx={{ ...SaveStyle, width: 200, textAlign: 'center' }}>
            <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                <NotificationImportantIcon sx={{ width: '60px', height: '60px', color: 'red' }} />
                <Typography sx={{ margin: '0 0px 10px', padding: '0px' }}>{message ? message : 'Are you sure want to delete?'}</Typography>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <Button onClick={() => onSubmit(selectedData)} variant='contained' sx={{ backgroundColor: '#3150A1', color: 'white', width: '50%' }} >Confirm</Button>
                    <Button onClick={() => onError()} variant='contained' sx={{ backgroundColor: 'red', color: 'white', width: '50%' }} color="error" > Cancel</Button>
                </Box>
            </Stack>
        </Box >
    </Modal >
}

const SaveStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    minHeight: 184,
    bgcolor: 'white',
    borderRadius: 4,
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};